import React from 'react'
import { QuickEnroll } from '../../../../containers/quick-enroll-modal'
import { AccountNav } from '../../AccountNav'
import { ReportsNav } from '../../ReportsNav'
import { baseStyles as styles } from '../_base'

export default function NavigationLinksWrapper(props) {
  return (
    <div className={styles.links}>
      <ReportsNav />
      <QuickEnroll {...props} />
      <AccountNav
        api={props.api}
        user_role={props.user_role}
        menuAnchorEl={props.menuAnchorEl}
        handleMenuOpen={props.handleMenuOpen}
        handleMenuClose={props.handleMenuClose}
        handleSnackbar={props.handleSnackbar}
        logout={props.logout}
        styles={styles}
      />
    </div>
  )
}
